import { createContext, useState } from 'react';

import { BASIC_INITIAL_STATE } from '../../../utils/HttpHelper';

// import LSCTouchpointData from './LSCTouchpointData';

export const LSCTouchpointStateContext = createContext();

const INITIAL_STATE = {
  ...BASIC_INITIAL_STATE
};

const LSCTouchpointContextProvider = ({ children }) => {
  const stateHook = useState(INITIAL_STATE);

  return (
    <LSCTouchpointStateContext.Provider value={stateHook}>
      {children}
    </LSCTouchpointStateContext.Provider>
  );
};

export default LSCTouchpointContextProvider;